import './styles/EventRegistrations.scss';
import { System_DeviceOrientationMap } from '../../assets/keyMap';
import { AppContext, ExAppContext } from '../../Context';
import { EventRegistrations_PageMap, EventRegistrations_SortModeMap, EventRegistration_StatusFilterMap, Payment_StatusMap, EventCategory_CategoryTypeMap } from '../../assets/keyMap';
import { Fragment, useContext, useState, useRef, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { IonDateString, IonDateFormat } from '../../components/IonDate';
import SelectionBox from '../../components/SelectionBox';
import OpenSansBase64 from '../../assets/base64s/openSans';
import jsPDF from 'jspdf';
import { FileOpener } from '@capacitor-community/file-opener';

//plugins
import InfinityEncryptor from '../../plugins/InfinityEncryptor';

//classes
import Event from '../../exClasses/event';
import EventRegistration from '../../exClasses/eventRegistration';
import SelectionList from '../../classes/selectionList';
import Payment from '../../exClasses/payment';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//handlers
import SwipeOverscrollHandler from '../../handlers/SwipeOverscrollHandler';

//mui
import SearchIcon from '@mui/icons-material/Search';
import FestivalIcon from '@mui/icons-material/Festival';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

//graphics
// import PPKMLogo from '../../assets/images/logos/ppkmLogo.jpg';
import { isPlatform } from '@ionic/react';
import MemberUser from '../../classes/memberUser';
// import MemberUser from '../../classes/memberUser';

const nonstate = {
    eventFetchBatchSize: 10
}

interface Props {

}

const EventRegistrations: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState<number>(EventRegistrations_PageMap.MAIN);
    const [eventRegistrations, SetEventRegistrations] = useState([] as EventRegistration[]);
    const [eventRegistrationPayments, SetEventRegistrationPayments] = useState([] as Payment[]);
    const [registrationEvents, SetRegistrationEvents] = useState([] as Event[]);

    const [selectionList_registrationStatus, SetSelectionList_registrationStatus] = useState([] as SelectionList[]);
    const [filter_registrationStatus, SetFilter_registrationStatus] = useState<string>('0');
    const [filter_searchString, SetFilter_searchString] = useState('');

    const [selectedEventRegistration, SetSelectedEventRegistration] = useState({} as EventRegistration);
    const [selectedRegistrationParticipants, SetSelectedRegistrationParticipants] = useState<MemberUser[]>([] as MemberUser[]);
    const [selectedPayment, SetSelectedPayment] = useState({} as Payment);
    const [selectedEvent, SetSelectedEvent] = useState({} as Event);
    const [preSearchString, SetPreSearchString] = useState('');
    const [detailsImgErr, SetDetailsImgErr] = useState(false as boolean);

    //references for PAGE UPCOMING_PAST

    //references
    const eventScrollRef = useRef<any>(null);
    const pageRef = useRef<number>(page);
    //router objs
    const history = useHistory();
    // const location = useLocation();
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    const iencryptor = new InfinityEncryptor('22499', 'MYDIH');

    //watchers
    //test
    // useEffect(() => {
    //     console.log('MyEventTest: ' + eventScrollRef.current);
    // }, [page]);

    //initialize, fetch all member associated eventRegistrations
    useEffect(() => {
        appContext.SetHeaderBackAction(() => () => {
            history.push('/Home');
        });

        databaseInterfaceController.Queue('fetchMemberEventRegistrations', [
            ['fetchMemberEventRegistrations', 'true'],
            ['memberID', exAppContext.membership.memberID]
        ]);

        //initialize statusFilterList
        const selectionList = [] as SelectionList[];
        Object.keys(EventRegistration_StatusFilterMap).map((key: string) => {
            selectionList.push({ key: EventRegistration_StatusFilterMap[key as keyof typeof EventRegistration_StatusFilterMap].toString(), value: key } as SelectionList);
        });
        SetSelectionList_registrationStatus([...selectionList]);
    }, []);

    //watch for eventRegistrations updated, fetch registrationPayments
    useEffect(() => {
        if (eventRegistrations.length > 0) {
            const registrationIDs = [] as string[];
            eventRegistrations.map((eventRegistration: EventRegistration) => {
                registrationIDs.push(eventRegistration.event_registrationID);
            });
            databaseInterfaceController.Queue('fetchEventRegistrationPaymentsByRegistrationIDs', [
                ['fetchEventRegistrationPaymentsByRegistrationIDs', 'true'],
                ['registrationIDs', registrationIDs.join(',')]
            ]);
            databaseInterfaceController.Queue('fetchRegistrationEventsByRegistrationIDs', [
                ['fetchRegistrationEventsByRegistrationIDs', 'true'],
                ['registrationIDs', registrationIDs.join(',')]
            ]);
        }
    }, [eventRegistrations]);

    //watch for selectedEventRegistration, fetch participants info
    useEffect(() => {
        if (
            Object.keys(selectedEventRegistration).length > 0
            && selectedEventRegistration.beneficiaryIDs.length > 0
        ) {
            databaseInterfaceController.Queue('fetchParticipantInfoByUserIDs', [
                ['fetchParticipantInfoByUserIDs', 'true'],
                ['userIDs', selectedEventRegistration.beneficiaryIDs]
            ]);
        } else {
            SetSelectedRegistrationParticipants([]);
        }
    }, [selectedEventRegistration]);

    //watch for page change update headerTitle & headerBackAction
    useEffect(() => {
        if (page != pageRef.current) {
            pageRef.current = page;

            switch (page) {
                // case EventRegistrations_PageMap.:
                // case EventRegistrations_PageMap.PAST:
                //     appContext.SetHeaderTitle('MY EVENTS');
                //     appContext.SetHeaderBackAction(() => function () { appContext.SetHeaderBackAction(history.push('/Home')) });
                //     break; --deprecated
                // case EventRegistrations_PageMap.TICKETS:
                //     appContext.SetHeaderTitle('QR CODE');
                //     appContext.SetHeaderBackAction(() => function () { SetPage(prevPageRef.current); SetCurrentSelectedEvent({} as Event); });
                //     break; --deprecated
                // case EventRegistrations_PageMap.DETAILS:
                //     appContext.SetHeaderTitle('EVENT DETAILS');
                //     appContext.SetHeaderBackAction(() => function () { SetPage(prevPageRef.current); SetCurrentSelectedEvent({} as Event); });
                //     break; ---deprecated
            }
        }
    }, [page]);

    //watch for databaseResultAction
    useEffect(() => {
        if (appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchMemberEventRegistrations':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            const _eventRegistrations = [] as EventRegistration[];

                            jsonObjs.map((obj: any) => {
                                _eventRegistrations.push(new EventRegistration(
                                    obj['event_registrationID'],
                                    obj['eventID'],
                                    obj['paymentID'],
                                    obj['initiatorID'],
                                    obj['beneficiaryIDs'],
                                    obj['doc_base_url'],
                                    obj['beneficiary_doc_ics'],
                                    obj['beneficiary_doc_passports'],
                                    obj['dietary_options'],
                                    obj['public_beneficiary_ids'],
                                    obj['public_beneficiary_salutations'],
                                    obj['public_beneficiary_fullnames'],
                                    obj['public_beneficiary_emails'],
                                    obj['public_beneficiary_phones'],
                                    obj['public_beneficiary_designations'],
                                    obj['public_beneficiary_doc_ics'],
                                    obj['public_beneficiary_doc_passports'],
                                    obj['public_beneficiary_rpm_nos'],
                                    obj['public_dietary_options'],
                                    obj['hrd_claim_status'],
                                    obj['hrd_grant_status'],
                                    obj['datetime_created'],
                                    obj['event_regRefIDs']
                                ));
                            });
                            SetEventRegistrations([..._eventRegistrations]);
                        } else {
                            console.log('fetchMemberEventRegistrationsErr: ' + res);
                        }
                        break;
                    case 'fetchEventRegistrationPaymentsByRegistrationIDs':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            const _eventRegistrationPayments = [] as Payment[];

                            jsonObjs.map((obj: any) => {
                                _eventRegistrationPayments.push(new Payment(
                                    obj['paymentID'],
                                    obj['invoice_no'],
                                    obj['type'],
                                    obj['status'],
                                    obj['contact_salutation'],
                                    obj['contact_other_salutation'],
                                    obj['contact_name'],
                                    obj['contact_hp'],
                                    obj['contact_office_no'],
                                    obj['contact_email'],
                                    obj['billing_name'],
                                    obj['billing_address'],
                                    obj['e_invoice_pin'],
                                    obj['itemIDs'],
                                    obj['pax'],
                                    obj['amounts'],
                                    obj['datetime_created'],
                                    obj['datetime_updated'],
                                    obj['remarks']
                                ));
                            });
                            SetEventRegistrationPayments([..._eventRegistrationPayments]);
                        } else {
                            console.log('fetchEventRegistrationPaymentsByRegistrationIDsErr: ' + res);
                        }
                        break;
                    case 'fetchRegistrationEventsByRegistrationIDs':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            const _registrationEvents = [] as Event[];

                            jsonObjs.map((obj: any) => {
                                _registrationEvents.push(new Event(
                                    obj['eventID'],
                                    obj['event_categoryID'],
                                    obj['event_name'],
                                    obj['event_name_highlight_texts'],
                                    obj['event_name_highlight_colors'],
                                    obj['event_desc'],
                                    obj['event_poster'],
                                    obj['event_file'],
                                    obj['event_venue'],
                                    obj['registration_start_date'],
                                    obj['registration_end_date'],
                                    obj['early_bird_start_date'],
                                    obj['early_bird_end_date'],
                                    obj['event_start_date'],
                                    obj['event_end_date'],
                                    obj['event_schedules'],
                                    obj['max_pax'],
                                    obj['hostID'],
                                    obj['datetime_created'],
                                    obj['datetime_updated'],
                                    obj['inapp_registration'],
                                    obj['external_registration_link']
                                ));
                            });
                            SetRegistrationEvents([..._registrationEvents]);
                        } else {
                            console.log('fetchRegistrationEventsByRegistrationIDs: ' + res);
                        }
                        break;
                    case 'fetchParticipantInfoByUserIDs':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            const memberUsers = [] as MemberUser[];
                            resObjs.map((resObj: any) => {
                                memberUsers.push(new MemberUser(
                                    '', '', '', '', '', '', '', '', '', '', '', '',
                                    resObj['email'],
                                    resObj['name'],
                                    '', '', '', '', '', '', '', '', '', '', '', '', '', ''
                                ));
                            });
                            SetSelectedRegistrationParticipants([...memberUsers]);
                        } else {
                            console.log('fetchMemberUsersByUserIDsErr: ' + res);
                        }
                        break;
                    // case 'fetchPaymentInvoice':
                    //     if (!JSON.stringify(res).includes('_false')) {
                    //         //preps
                    //         let html_content = res.replace(/\{DeviceWidth\}/g, window.innerWidth);
                    //         html_content = html_content.replace(/\{ScaledHeight\}/g, window.innerWidth * /*1.414*/ 1.2);
                    //         html_content = html_content.replace(/\{ScaledFontSize\}/g, window.innerWidth * .015);
                    //         html_content = html_content.replace(/\{ScaledFontSize2\}/g, window.innerWidth * .016);
                    //         const elem = document.createElement('div');
                    //         elem.innerHTML = html_content;

                    //         //show wait screen
                    //         appContext.SetWaitScreenMessage('Generating invoice please wait');
                    //         appContext.SetWaitScreenShouldShow(true);

                    //         //start generate invoice pdf
                    //         document.body.appendChild(elem);

                    //         const doc = new jsPDF({
                    //             orientation: 'portrait',
                    //             unit: 'mm',
                    //             format: 'a4'
                    //         });
                    //         doc.addFileToVFS("OpenSans-Variable.ttf", OpenSansBase64);
                    //         doc.addFont("OpenSans-Variable.ttf", "Open Sans", "normal");
                    //         doc.addFont("OpenSans-Variable.ttf", "Open Sans Bold", "bold");
                    //         doc.setFont("Open Sans");
                    //         doc.html(elem, {
                    //             callback: async (doc: any) => {
                    //                 //delete last page (usually blanks)
                    //                 const pageCount = doc.internal.getNumberOfPages();
                    //                 if (pageCount > 1)
                    //                     doc.deletePage(pageCount);

                    //                 //out put pdf
                    //                 document.body.removeChild(elem);
                    //                 const blob = doc.output('blob');
                    //                 const url = URL.createObjectURL(blob);
                    //                 appContext.SetAppStateChangeWatch(false);
                    //                 if (isPlatform('hybrid')) {
                    //                     await SaveBlobToCache(blob).then(async (res: any) => {
                    //                         console.log('checkRes: ' + JSON.stringify(res));
                    //                     });
                    //                     appContext.SetAppStateChangeWatch(true);
                    //                     appContext.SetWaitScreenShouldShow(false);
                    //                     appContext.SetPopupMessage('Invoice generated.');
                    //                 } else {
                    //                     //browser version dont support browser listener
                    //                     appContext.SetAppStateChangeWatch(true);
                    //                     appContext.SetWaitScreenShouldShow(false);
                    //                     appContext.SetPopupMessage('Invoice generated.');
                    //                 }
                    //             },
                    //             x: 0, y: 0,
                    //             width: 210,
                    //             windowWidth: window.innerWidth
                    //         });
                    //     } else {
                    //         console.log('fetchPaymentInvoiceErr: ' + res);
                    //     }
                    //     break; ---deprecated to use invoiceControl.php
                }
            };
            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchMemberEventRegistrations':
                case 'fetchEventRegistrationPaymentsByRegistrationIDs':
                case 'fetchRegistrationEventsByRegistrationIDs':
                case 'fetchParticipantInfoByUserIDs':
                    // case 'fetchPaymentInvoice': --deprecated to use invoiceControl.php
                    ExecuteDatabaseResultAction();
                    break;
            }

        }
    }, [appContext.databaseActionModeQueue[0], appContext.databaseResultAction]);

    //ui functions
    const OnSearchBtnClicked = () => {
        SetFilter_searchString(preSearchString);
    }
    const OnViewMoreInfoClicked = (eventRegistration: EventRegistration, payment: Payment, event: Event) => {
        SetSelectedEventRegistration(eventRegistration);
        SetSelectedPayment(payment);
        SetSelectedEvent(event);
        SetPage(EventRegistrations_PageMap.REGISTRATION_INFO);
    }
    // const OnPaymentDetailsClicked = () => {
    //     //open payment details menu
    // } ---deprecated of unuse
    const OnGenerateInvoiceClicked = () => {
        //regenerate payment invoice
        // databaseInterfaceController.Queue('fetchPaymentInvoice', [
        //     ['fetchPaymentInvoice', 'true'],
        //     ['paymentID', selectedPayment.paymentID]
        // ]); ---deprecated to use invoiceControl.php

        const url = 'https://www.ppkm.org.my/mobile_backend/scripts/invoiceControl.php?fetchPaymentInvoice=' + iencryptor.Encrypt('true') + '&paymentID=' + iencryptor.Encrypt(selectedPayment.paymentID);
        window.open(url, '_blank');
    }

    //render functions
    const RenderPages = () => {
        switch (page) {
            default:
            case EventRegistrations_PageMap.MAIN:
                return RenderMainPage();
            case EventRegistrations_PageMap.REGISTRATION_INFO:
                return RenderRegistrationInfoPage();
        }
    }
    const RenderTopOptions = () => {
        switch (page) {
            case EventRegistrations_PageMap.MAIN:
                return (
                    <Fragment>
                        <div className='option-panel-row'>
                            <div className='search-bar'>
                                <input className='search-bar-in' onChange={(e: any) => { SetPreSearchString(e.target.value) }} value={preSearchString} onFocus={() => SetPreSearchString('')} placeholder='search' />
                                <button className='search-btn' onClick={() => OnSearchBtnClicked()}><SearchIcon /></button>
                            </div>
                            <button className='ppkm-events-btn' onClick={() => history.push('/Events')}>
                                <FestivalIcon />
                                PPKM<br />Events
                            </button>
                        </div>
                    </Fragment>
                );
        }
    }
    const RenderBottomOptions = () => {
        switch (page) {
            case EventRegistrations_PageMap.MAIN:
                return (
                    <Fragment>
                        <div className='filter-panel'>
                            <span className='filter-panel-title'>Filter By</span>
                            <SelectionBox selectionList={selectionList_registrationStatus} selectingKey={filter_registrationStatus} SetSelectingKey={SetFilter_registrationStatus} direction='up' />
                        </div>
                        <div className='scroll-nav-panel'>
                            <button className='scroll-nav-btn' onClick={() => { eventScrollRef.current.scrollTo({ top: 0, behaviour: 'smooth' }); }}><ArrowDropUpIcon /></button>
                            <button className='scroll-nav-btn' onClick={() => { eventScrollRef.current.scrollTo({ top: eventScrollRef.current.scrollHeight, behaviour: 'smooth' }); }}><ArrowDropDownIcon /></button>
                        </div>
                    </Fragment>
                )
        }
    }
    const RenderMainPage = () => {
        const filteredRegistrations = FilterEventsBySearchString(
            FilterEventRegistrationsByStatus(eventRegistrations)
        );

        return (
            <div className='page' ref={eventScrollRef}>
                {
                    filteredRegistrations.length > 0 ?
                        filteredRegistrations.map((eventRegistration: EventRegistration, i: number) => {
                            return RenderEventRegistrationCard(eventRegistration, i)
                        })
                        :
                        <span className='events-scroll-lbl'>There're no current events found</span>
                }
            </div>
        )
    }
    const RenderEventRegistrationCard = (eventRegistration: EventRegistration, i: number) => {
        const payment = GetRegistrationPaymentByID(eventRegistration.paymentID);
        const paymentStatus = (payment.status == Payment_StatusMap.PENDING ? 'pending' : (payment.status == Payment_StatusMap.PAID ? 'paid' : (payment.status == Payment_StatusMap.UNPAID ? 'unpaid' : '')));
        const event = GetRegistrationEventByID(eventRegistration.eventID);

        return (
            <div className='event-registration-card' key={'event-registration-card-' + i}>
                <div className='card-header'>
                    <span className='date-lbl'>Registered on {IonDateString(payment.datetime_created, IonDateFormat.MALAYSIA_STANDARD_DATE)}</span>
                    <span className={'status-lbl ' + paymentStatus}>payment {paymentStatus}</span>
                </div>
                <div className='card-body'>
                    <div className='card-col'>
                        <div className='card-row'>
                            <span className='card-lbl'>Registration No.</span>
                            <span className='card-txt'>{eventRegistration.event_registrationID}</span>
                        </div>
                        <div className='card-row'>
                            <span className='card-lbl'>Event Title.</span>
                            <span className='card-txt'>{event.event_name}</span>
                        </div>
                        <div className='card-row'>
                            <span className='card-lbl'>Invoice No.</span>
                            <span className='card-txt'>{payment.invoice_no}</span>
                        </div>
                    </div>
                    <div className='card-col ex'>
                        <button className='card-option-btn' onClick={() => OnViewMoreInfoClicked(eventRegistration, payment, event)}><InfoIcon />More Info</button>
                    </div>
                </div>
            </div>
        )
    }
    const RenderRegistrationInfoPage = () => {
        let paymentStatus = '';
        switch (selectedPayment.status) {
            case Payment_StatusMap.PENDING:
                paymentStatus = 'pending';
                break;
            case Payment_StatusMap.PAID:
                paymentStatus = 'paid';
                break;
            case Payment_StatusMap.UNPAID:
                paymentStatus = 'unpaid';
                break;
            case Payment_StatusMap.HRDC_PAID:
                paymentStatus = 'hrdc paid';
                break;
        }
        // const paymentStatus = (selectedPayment.status == Payment_StatusMap.PENDING ? 'pending' : (selectedPayment.status == Payment_StatusMap.PAID ? 'paid' : (selectedPayment.status == Payment_StatusMap.UNPAID ? 'unpaid' : '')));
        let paymentAmount = 0;
        selectedPayment.amounts.map((amount: number) => {
            paymentAmount += amount;
        });
        paymentAmount = paymentAmount * selectedPayment.pax;

        // let paymentDue = selectedPayment.datetime_created;
        // if (paymentDue != null)
        //     paymentDue = AddDaysToDate(paymentDue, 14); ---deprecated of unuse

        return (
            <div className='menu'>
                <span className='menu-title'>Registration Info</span>
                <div className='menu-scroll'>
                    <div className='menu-col'>
                        {
                            paymentStatus == 'pending' ?
                                <span className={'menu-txt ex left'}>PPK Secretariat will be in contact soon regarding your payment documentations.</span>
                                :
                                null
                        }
                    </div>
                    <div className='menu-col'>
                        <span className='menu-lbl'>Registration No.</span>
                        <span className='menu-txt'>{selectedEventRegistration.event_registrationID}</span>
                    </div>
                    <div className='menu-col'>
                        <span className='menu-lbl'>Event Title</span>
                        <span className='menu-txt'>{selectedEvent.event_name}</span>
                    </div>
                    <div className='menu-col'>
                        <span className='menu-lbl'>Participant(s)</span>
                        {
                            selectedRegistrationParticipants.map((participant: MemberUser, i: number) => {
                                return (
                                    <div className='menu-row'>
                                        <span className='menu-txt ex2'>{(i + 1).toString()} .</span>
                                        <span className='menu-txt ex2'>{participant.name}</span>
                                        <span className='menu-txt ex2'>{participant.email.replace(/\s/g, '').length > 0 ? participant.email : 'NA'}</span>
                                    </div>
                                )
                            })
                        }
                        {
                            selectedEventRegistration.public_beneficiary_fullnames.map((name: string, i: number) => {
                                return (
                                    <div className='menu-row'>
                                        <span className='menu-txt ex2'>{(selectedRegistrationParticipants.length + i + 1).toString()} .</span>
                                        <span className='menu-txt ex2'>{name}</span>
                                        <span className='menu-txt ex2'>{selectedEventRegistration.public_beneficiary_emails[i]}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {/* <div className='menu-col'>
                        <span className='menu-lbl'>Payment Invoice No.</span>
                        <span className='menu-txt'>{selectedPayment.invoice_no}</span>
                    </div> ---deprecated of unuse*/}
                    {/* <div className='menu-col'>
                        <span className='menu-lbl'>Payment Amount</span>
                        <span className={'menu-txt '}>{'RM ' + paymentAmount.toFixed(2)}</span>
                    </div> */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Payment Status</span>
                        <span className={'menu-txt ' + paymentStatus}>{paymentStatus}</span>
                    </div>
                    {/* {
                        paymentStatus == 'pending' ?
                            <div className='menu-col'>
                                <span className='menu-txt ex'>* Please complete your payment before {IonDateString(paymentDue, IonDateFormat.LONG_DATE)} to prevent your registration being forfeit.</span>
                            </div>
                            :
                            null
                    } ---deprecated of unuse*/}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Billing Name</span>
                        <span className='menu-txt'>{selectedPayment.billing_name}</span>
                    </div>
                    <div className='menu-col'>
                        <span className='menu-lbl'>Billing Address</span>
                        <span className='menu-txt left'>{selectedPayment.billing_address}</span>
                    </div>
                    {
                        selectedPayment.e_invoice_pin.length > 0 ?
                            <div className='menu-col'>
                                <span className='menu-lbl'>E-Invoice Pin /Tin No.</span>
                                <span className='menu-txt'>{selectedPayment.e_invoice_pin}</span>
                            </div>
                            :
                            null
                    }
                    <div className='menu-col'>
                        <span className='menu-lbl'>Contact Person's Name</span>
                        <span className='menu-txt'>{selectedPayment.contact_name}</span>
                    </div>
                    <div className='menu-col'>
                        <span className='menu-lbl'>Contact Person's Mobile No.</span>
                        <span className='menu-txt'>{selectedPayment.contact_hp}</span>
                    </div>
                    <div className='menu-col'>
                        <span className='menu-lbl'>Contact Person's Office No.</span>
                        <span className='menu-txt'>{selectedPayment.contact_office_no}</span>
                    </div>
                    <div className='menu-col'>
                        <span className='menu-lbl'>Contact Person's Email</span>
                        <span className='menu-txt'>{selectedPayment.contact_email}</span>
                    </div>
                </div>
                <button className='menu-close-btn' onClick={() => SetPage(EventRegistrations_PageMap.MAIN)}><CloseIcon /></button>
                <div className='menu-option-panel'>
                    {
                        paymentStatus != 'paid' ?
                            // <button className='menu-option-btn' onClick={() => OnGenerateInvoiceClicked()}>Generate Invoice</button> --deprecated
                            null
                            :
                            <button className='menu-option-btn' onClick={() => history.push('/MyEvents/3/' + selectedEventRegistration.eventID)}>View Tickets</button>
                    }
                </div>
            </div>
        );
    }

    //exe function
    // const GetKeyOfObjectByValue = (obj: any, value: any) => {
    //     let res = '';
    //     Object.keys(obj).map((key: string) => {
    //         if (obj[key] == value)
    //             res = key;
    //     });
    //     return res;
    // }
    // const SortEventsByDate = (events: Event[], mode: number) => {
    //     const sorted = [] as Event[];
    //     events.map((event: Event) => {
    //         let isSorted = false;
    //         sorted.map((sort: Event, i: number) => {
    //             if (!isSorted &&
    //                 (event.event_start_datetime! && sort.event_start_datetime!) &&
    //                 (
    //                     mode == EventRegistrations_SortModeMap.DESCENDING ?
    //                         event.event_start_datetime >= sort.event_start_datetime
    //                         :
    //                         event.event_start_datetime < sort.event_start_datetime
    //                 )
    //             ) {
    //                 sorted.splice(i, 0, event);
    //                 isSorted = true;
    //             }
    //         });
    //         if (!isSorted)
    //             sorted.push(event);
    //     });

    //     return sorted;
    // }
    // const GetMembershipUserByID = (userID: string) => {
    //     let res = {} as MemberUser;
    //     exAppContext.membershipUsers.map((memberUser: MemberUser) => {
    //         if (memberUser.userID == userID)
    //             res = memberUser;
    //     });
    //     return res;
    // }
    // const NRICMask = (nric: string) => {
    //     return 'xxxxxx-xx-' + nric.substring(8, 12);
    // } ---deprecated of unuse
    const FilterEventRegistrationsByStatus = (eventRegistration: EventRegistration[]) => {
        const res = [] as EventRegistration[];
        eventRegistration.map((eventRegistration: EventRegistration) => {
            const payment = GetRegistrationPaymentByID(eventRegistration.paymentID);
            switch (parseInt(filter_registrationStatus)) {
                case EventRegistration_StatusFilterMap.ALL:
                    res.push(eventRegistration);
                    break;
                case EventRegistration_StatusFilterMap.PENDING:
                    if (payment.status == Payment_StatusMap.PENDING)
                        res.push(eventRegistration);
                    break;
                case EventRegistration_StatusFilterMap.SUCCESSFUL:
                    if (payment.status == Payment_StatusMap.PAID)
                        res.push(eventRegistration);
                    break;
                case EventRegistration_StatusFilterMap.FAILED:
                    if (payment.status == Payment_StatusMap.UNPAID)
                        res.push(eventRegistration);
                    break;
            }
        });
        return res;
    }
    const FilterEventsBySearchString = (eventRegistrations: EventRegistration[]) => {
        let filtered = [] as EventRegistration[];
        if (filter_searchString != '') {
            eventRegistrations.map((eventRegistration: EventRegistration) => {
                const event = GetRegistrationEventByID(eventRegistration.eventID);
                if (event.event_name.toUpperCase().includes(filter_searchString.toUpperCase())) {
                    filtered.push(eventRegistration);
                }
            });
        } else
            filtered = eventRegistrations;
        return filtered;
    }
    const GetRegistrationEventByID = (eventID: string) => {
        let res = {} as Event;
        registrationEvents.map((event: Event) => {
            if (event.eventID == eventID)
                res = event;
        });
        return res;
    }
    const GetRegistrationPaymentByID = (paymentID: string) => {
        let res = {} as Payment;
        eventRegistrationPayments.map((payment: Payment) => {
            if (payment.paymentID == paymentID)
                res = payment;
        });
        return res;
    }
    const AddDaysToDate = (date: Date, daysToAdd: number) => {
        const result = new Date(date);  // Create a copy of the date
        result.setDate(result.getDate() + daysToAdd);  // Add the days
        return result;
    }
    const SaveBlobToCache = async (blob: Blob) => {
        try {
            // Convert the Blob to a Uint8Array
            //   const arrayBuffer = await blob.arrayBuffer();
            // //   const uint8Array = new Uint8Array(arrayBuffer);
            BlobToBase64(blob).then(async (base64String: any) => {
                // Define the file name and path
                const filePath = `invoice.pdf`;

                // Write the file to the Cache directory
                const writeResult = await Filesystem.writeFile({
                    path: filePath,
                    data: base64String,
                    directory: Directory.Cache,
                });

                // Browser.addListener('browserFinished', () => {
                //     //end of pdf generation
                //     appContext.SetAppStateChangeWatch(true);
                //     appContext.SetWaitScreenShouldShow(false);
                //     SetPage(Events_PageMap.INVOICE_COMPLETE);
                // });
                // await Browser.open({ url: writeResult.uri });
                FileOpener.open({
                    filePath: writeResult.uri,
                    contentType: 'application/pdf',
                    openWithDefault: true
                });
                return writeResult.uri;  // Return the file URI (path to the saved file)
            }).catch((err: string) => { console.log('BlobToBase64Err: ' + err); });
        } catch (error) {
            console.error('Error saving Blob to cache:', error);
        }
    }
    const BlobToBase64 = (blob: Blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            // When the file is loaded, resolve the promise with the base64 string
            reader.onloadend = () => {
                resolve(reader.result); // This is the base64 string
            };

            // Handle any errors that occur during the read operation
            reader.onerror = (error) => {
                reject(error);
            };

            // Read the blob as a data URL (base64)
            reader.readAsDataURL(blob);
        });
    }
    const RefetchMembershipEventRegistrations = () => {
        databaseInterfaceController.Queue('fetchMemberEventRegistrations', [
            ['fetchMemberEventRegistrations', 'true'],
            ['memberID', exAppContext.membership.memberID]
        ]);
    }

    return (
        <div className={'EventRegistrations ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className='option-panel'>
                {RenderTopOptions()}
                {RenderBottomOptions()}
                {/* <div className='filter-panel'>
                    <span className='filter-panel-title'>Filter By</span>
                    <SelectionBox selectionList={selectionList_eventCategory} selectingKey={filter_eventCategory} SetSelectingKey={SetFilter_eventCategory} direction='up' />
                </div> ---deprecated */}
            </div>
            {
                RenderPages()
            }

            {/** SwipeOverscrollHandlers */}
            <SwipeOverscrollHandler targetRef={eventScrollRef} action={() => RefetchMembershipEventRegistrations()} />
            {/* <SwipeOverscrollHandler targetRef={eventScrollRef} action={() => RefetchUserEvents()} /> */}
            {/* <SwipeOverscrollHandler targetRef={qrCardScrollMaskRef} direction='right-to-left' animation={false} action={() => OnNavigateToNextQr()} />
            <SwipeOverscrollHandler targetRef={qrCardScrollMaskRef} direction='left-to-right' animation={false} action={() => OnNavigateToPrevQr()} /> --deprecated */}
        </div>
    )
}
export default EventRegistrations;